module.exports = __webpack_public_path__ + "img/image22@2x.15505a8e.png";